import { getReadingStorageKey } from "./readingStorageScope";

const STORAGE_POSITIONS = "bible_reading_positions";
const STORAGE_BOOKMARKS = "bible_bookmarks";
export const EVENT_BOOKMARKS_CHANGED = "bible_bookmarks_changed";

const readJsonMap = (key) => {
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch (e) {
    return {};
  }
};

export const saveChapterVersePosition = (chapterId, verse, uid) => {
  const num = Number(verse);
  if (!chapterId || !Number.isFinite(num) || num < 1) return;
  try {
    const key = getReadingStorageKey(STORAGE_POSITIONS, uid);
    const map = readJsonMap(key);
    map[chapterId] = {
      verse: num,
      updatedAt: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(map));
  } catch (e) {
    // ignore storage error
  }
};

export const getChapterVersePosition = (chapterId, uid) => {
  if (!chapterId) return null;
  const key = getReadingStorageKey(STORAGE_POSITIONS, uid);
  const map = readJsonMap(key);
  const entry = map[chapterId];
  const verse = typeof entry === "number" ? entry : entry?.verse;
  return Number.isFinite(Number(verse)) && Number(verse) >= 1
    ? Number(verse)
    : null;
};

export const getBookmarks = (uid) => {
  try {
    const key = getReadingStorageKey(STORAGE_BOOKMARKS, uid);
    const raw = localStorage.getItem(key);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

const writeBookmarks = (list, uid) => {
  try {
    const key = getReadingStorageKey(STORAGE_BOOKMARKS, uid);
    localStorage.setItem(key, JSON.stringify(list));
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event(EVENT_BOOKMARKS_CHANGED));
    }
  } catch (e) {
    // ignore storage error
  }
};

export const buildBookmarkId = (chapterId, verse = 1) =>
  `${chapterId}:${Number(verse) || 1}`;

export const addBookmark = (
  { chapterId, bookName = "", chapterNumber = 1, verse = 1, verseText = "" },
  uid
) => {
  if (!chapterId) return getBookmarks(uid);
  const resolvedVerse = Number(verse) || 1;
  const id = buildBookmarkId(chapterId, resolvedVerse);
  const current = getBookmarks(uid).filter((b) => b.id !== id);
  const next = [
    {
      id,
      chapterId,
      bookName,
      chapterNumber: Number(chapterNumber) || 1,
      verse: resolvedVerse,
      verseText: String(verseText || "").slice(0, 160),
      createdAt: Date.now(),
    },
    ...current,
  ];
  writeBookmarks(next, uid);
  return next;
};

export const removeBookmark = (id, uid) => {
  if (!id) return getBookmarks(uid);
  const next = getBookmarks(uid).filter((b) => b.id !== id);
  writeBookmarks(next, uid);
  return next;
};

export const toggleBookmark = (payload, uid) => {
  if (!payload?.chapterId) return { added: false, list: getBookmarks(uid) };
  const resolvedVerse = Number(payload.verse) || 1;
  const id = buildBookmarkId(payload.chapterId, resolvedVerse);
  const existing = getBookmarks(uid).some((b) => b.id === id);
  if (existing) {
    return { added: false, list: removeBookmark(id, uid) };
  }
  return {
    added: true,
    list: addBookmark({ ...payload, verse: resolvedVerse }, uid),
  };
};

export const getChapterBookmarks = (chapterId, uid) => {
  if (!chapterId) return [];
  return getBookmarks(uid).filter((b) => b.chapterId === chapterId);
};
